import React from 'react';
import styles from './Photo.module.css';
import { Avatar } from '../Avatar/Avatar';
import tree from '../../assets/images/tree.png';

export const Photo = ({ message, isVertical }) => {
  return (
    <div
      style={{
        height: isVertical ? 'calc(100vh - 20rem)' : 'calc(100vh - 34rem)',
      }}
      className={styles.photo}>
      <img src={message?.attachments[0].url} alt={''} />
      <Avatar message={message} />
      <div className={styles.treeBlock}>
        <img src={tree} alt="tree" />
      </div>
    </div>
  );
};
